<template>

    <div class="content-overlay sub-plan">

        <div class="in-content" :class="{ clsng : Global.tempSubClosingOverlay }">

            <div class="head">
                <span class="x" @click.prevent="closeSubOverlay">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M19.4706 2.5L2.5 19.4706" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    <path d="M19.4706 19.4706L2.5 2.5" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    </svg>
                </span>
            </div>

            <PlanCard :plan="Global.plans[1]"></PlanCard>
            
        </div>
        
    </div>

</template>

<script>

    import PlanCard from './PlanCard'
    import Global from '../lib/GlobalState'

    export default {

        name: 'SubOverlay',

        components: {
            PlanCard,
        },

        data() {
            return {
                Global,
            }
        },

        methods: {

            
            closeSubOverlay() {

                this.Global.tempSubClosingOverlay = true
                setTimeout(() => { this.Global.activeSubOverlay = false }, 300)
                setTimeout(() => { this.Global.activeSubInfoOverlay = false }, 600)

            },

        }
    }
</script>